import React, {Component} from 'react';
import Utils from '../utils';

class TeamMembers extends Component{
    

    render() {
        return (
            <div className="section" data-location={this.props.currentRegion}>
                <div className="description">
                    <h2>{this.props.currentRegionLabel}</h2>
                </div>
                <div className="team-members">
                    <div className="team-members-wrapper">
                        <div className="member">
                            <div className="member--image">
                                <img src="./img/people/people__placeholder.jpg" />
                            </div>
                            <div className="member--details">
                                <p>Test Name</p>
                                <p>Job Title</p>
                                <p>02849 240418</p>
                            </div>
                        </div>
                        <div className="member">
                            <div className="member--image">
                                <img src="./img/people/people__placeholder.jpg" />
                            </div>
                            <div className="member--details">
                                <p>Test Name</p>
                                <p>Job Title</p>
                                <p>02849 240418</p>
                            </div>
                        </div>
                        <div className="member">
                            <div className="member--image">
                                <img src="./img/people/people__placeholder.jpg" />
                            </div>
                            <div className="member--details">
                                <p>Test Name</p>
                                <p>Job Title</p>
                                <p>02849 240418</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TeamMembers;


// WEBPACK FOOTER //
// ./src/js/components/TeamMembers.js